<template>
  <div class="dashboard">
    <section class="page">
      <div class="page__Pending">
        <icon name="users" />
        <h2>Your organisation is pending approval</h2>
        <p>
          Hey, thanks for getting on board! Seems your organisation is still pending approval. You will be notified via
          e-mail as soon as one of our representatives accepts your request.
        </p>

        <button @click="logOut()">Log-in with a different account</button>
        <a href=""></a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Pending',
  methods: {
    logOut() {
      localStorage.removeItem('token')
      this.$router.push({ path: '/login' })
    },
  },
}
</script>
